// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__1e1YY","actions":"GroupTable_actions__xC-Mz","deleteModalFooter":"GroupTable_deleteModalFooter__1dDzL"};